import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/icons/graduation-hat-02-remove.tsx
function r({ colors: r, style: i, ...a }) {
	return /* @__PURE__ */ n("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(r),
			...i
		},
		...a,
		children: [
			/* @__PURE__ */ t("path", {
				d: "M18 11.6178L12.8047 14.2154C12.7253 14.2551 12.515 14.3708 12.2764 14.4156C12.0937 14.4498 11.9063 14.4498 11.7236 14.4156C11.485 14.3708 11.2747 14.2551 11.1953 14.2154L6 11.6178V16.0113C6 16.2028 6.00044 16.3014 6.00488 16.3726C6.00501 16.3747 6.00476 16.3766 6.00488 16.3785C6.00671 16.3796 6.00871 16.3812 6.01074 16.3824C6.07251 16.4182 6.16094 16.4629 6.33203 16.5484L11.7314 19.2476C11.8718 19.3178 11.9433 19.3536 11.9961 19.3765C11.9974 19.3771 11.9988 19.377 12 19.3775C12.0012 19.377 12.0026 19.3771 12.0039 19.3765C12.0567 19.3536 12.1282 19.3178 12.2686 19.2476L17.668 16.5484C17.8391 16.4629 17.9275 16.4182 17.9893 16.3824C17.991 16.3814 17.9925 16.3794 17.9941 16.3785C17.9943 16.3766 17.995 16.3747 17.9951 16.3726C17.9996 16.3014 18 16.2028 18 16.0113V11.6178ZM4.23535 8.49959L12 12.3814L19.7637 8.49959L12 4.61776L4.23535 8.49959ZM20 16.2418C19.9979 16.4866 19.9823 16.7677 19.8906 17.0338C19.794 17.314 19.6361 17.57 19.4287 17.7818C19.1662 18.0498 18.8187 18.2084 18.5625 18.3365L13.1631 21.0367C12.9526 21.1419 12.6766 21.2905 12.3691 21.3482C12.1254 21.394 11.8746 21.394 11.6309 21.3482C11.3234 21.2905 11.0474 21.1419 10.8369 21.0367L5.4375 18.3365C5.18135 18.2084 4.83383 18.0498 4.57129 17.7818C4.36386 17.57 4.20604 17.314 4.10938 17.0338C4.01769 16.7677 4.00205 16.4866 4 16.2418V10.6178L1.55273 9.39412C1.2142 9.22475 1.00016 8.87909 1 8.50057C1 8.12186 1.21405 7.77546 1.55273 7.60604L11.1953 2.78475C11.2748 2.745 11.4851 2.62931 11.7236 2.58455L11.8613 2.566C11.9536 2.55743 12.0464 2.55743 12.1387 2.566L12.2764 2.58455L12.4482 2.62947C12.6119 2.68261 12.745 2.75492 12.8047 2.78475L22.4473 7.60604C22.786 7.77546 23 8.12186 23 8.50057C22.9998 8.87909 22.7858 9.22475 22.4473 9.39412L20 10.6178V16.2418Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ n("g", {
				clipPath: "url(#clip0_15682_30465)",
				children: [/* @__PURE__ */ t("path", {
					d: "M18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23Z",
					fill: "var(--icon-color-on, var(--color-icon-on, white))"
				}), /* @__PURE__ */ t("path", {
					d: "M16 18H20M23 18C23 20.7614 20.7614 23 18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18Z",
					stroke: "var(--icon-color-primary, currentColor)",
					strokeWidth: "1.5",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", {
				id: "clip0_15682_30465",
				children: /* @__PURE__ */ t("rect", {
					width: "12",
					height: "12",
					fill: "var(--icon-color-primary, currentColor)",
					transform: "translate(12 12)"
				})
			}) })
		]
	});
}
//#endregion
export { r as GraduationHat02RemoveIcon };
